import Mediator from 'mediator-js';

/**
 * SignalsModule is a class that facilitates communication between different parts of an application
 * using a mediator pattern. It allows for subscribing to signals, emitting signals, and removing subscriptions.
 */
class SignalsModule {
    /**
     * Constructs a new SignalsModule instance.
     * Initializes the mediator with a unique identifier.
     */
    constructor() {
        this._mediator = new Mediator('myspace' + Math.random());
        this._mediator.identifier = Math.random() + '/' + (new Date()).getTime();
    }

    /**
     * Subscribes to a signal with a callback function.
     * @param {string} signal - The name of the signal to subscribe to.
     * @param {Function} callback - The callback function to be executed when the signal is emitted.
     * @returns {Object} - The subscription object.
     */
    on(signal, callback) {
        return this._mediator.subscribe(signal, callback);
    }

    /**
     * Emits a signal with provided arguments.
     * @param {string} signal - The name of the signal to emit.
     * @param {...*} args - Additional arguments to pass to the signal's subscribers.
     */
    emit(signal, ...args) {
        this._mediator.publish(signal, ...args);
    }

    /**
     * Gets the subscribers for a given signal.
     * @param {string} signal - The name of the signal.
     * @returns {Array} - An array of subscriber objects for the given signal.
     */
    getSubscriberId(signal) {
        return this._mediator.getChannel(signal)._subscribers;
    }

    /**
     * Removes a subscription from a signal.
     * @param {string} signal - The name of the signal.
     * @param {Function} callback - The callback function to remove from the signal's subscribers.
     * @returns {boolean} - True if the subscription was removed, false otherwise.
     */
    remove(signal, callback) {
        return this._mediator.remove(signal, callback);
    }
}

export default SignalsModule;